import "font-awesome/css/font-awesome.css";
import "bootstrap-loader";
import "./css/app.css"
import awake from "./js/awake.js";

awake();



// WEBPACK FOOTER //
// ./app.js